import { Button, Grid, Tooltip, CircularProgress } from "@mui/material";
import dots from '../Icons/dots-2.svg'
import parliament from '../images/parliament-meeting.svg'
import like from '../Icons/like.svg';
import comment from '../Icons/comment.svg';
import repost from '../Icons/re-post.svg';
import share from '../Icons/share.svg';
import addoption from '../Icons/add-option.svg'
import { useState, useEffect } from "react";
import PollCreator from "../components/PollCreator";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api, { noauthinstance } from "../utils/api";
import { BsToggleOn, BsToggleOff } from 'react-icons/bs';

function Survey_Polls() {

    const [pollQuestion, setPollQuestion] = useState('');
    const [pollChoices, setPollChoices] = useState(['']);
    const [triggerRefresh, setTriggerRefresh] = useState(0)
    const [loading, setLoading] = useState(false);
    console.log('pollchoices', pollChoices)
    const dataaa = pollChoices.map((text) => {
        console.log('poll text', text)
        return (
            { text }
        )
    })

    const handleQuestionChange = (e) => {
        setPollQuestion(e.target.value);
    };

    const handleChoiceChange = (e, index) => {
        const updatedChoices = [...pollChoices];
        updatedChoices[index] = e.target.value;
        setPollChoices(updatedChoices);
    };

    const handleAddChoice = () => {
        setPollChoices([...pollChoices, '']);
    };

    const handlePollSubmit = async (e) => {
        e.preventDefault();

        const filteredChoices = pollChoices.filter((choice) => choice.trim() !== '');

        console.log({ filteredChoices })

        if (filteredChoices.length === 0) {
            alert('At least one choice is required.');
            return;
        }

        const pollData = {
            question: pollQuestion,
            choices: dataaa,
        };


        // const polldata = {
        //     "question": "Favorite Color",
        //     "choices": [
        //         { "text": "Red" },
        //         { "text": "Blue" },
        //         { "text": "Green" }
        //     ]
        // }
        console.log({ pollData })

        try {
            setLoading(true);
            const accessToken = localStorage.getItem('accessToken');
            console.log(accessToken)
            if (!accessToken) {
                throw new Error('Authentication credentials were not provided.');
            }

            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const { data, status } = await noauthinstance.post('polls/', pollData, { headers });
            console.log({ pollData })
            if (data) {
                toast.success('Poll successfully created!')
                console.log('Poll successfully created!');
                setPollQuestion('');
                setPollChoices(['']);
                setTriggerRefresh(prev => prev + 1)
                console.log('pollwholedata', setPollChoices)
            } else {
                console.error('Error creating the poll.');
                toast.error("Error creating the poll")
            }
        } catch (error) {
            console.error('An error occurred:', error);
            toast.error("Error creating the poll")
        }
        finally {
            setLoading(false);
            setShowAnnouncement(prev => !prev);
        }
    };


    const [pollData, setPollData] = useState([]);
    const [userVotes, setUserVotes] = useState([]);
    const [toggleStates, setToggleStates] = useState([]);
    useEffect(() => {
        async function fetchPollData() {
            try {
                setLoading(true);
                const accessToken = localStorage.getItem('accessToken');
                if (!accessToken) {
                    throw new Error('Authentication credentials were not provided.');
                }

                const headers = {
                    Authorization: `Bearer ${accessToken}`,
                };

                const { data, status } = await noauthinstance.get('polls/', { headers });

                if (status === 200) {
                    setPollData(data);

                    const initialUserVotes = {};
                    data.forEach((poll) => {
                        poll.choices.forEach((choice) => {
                            initialUserVotes[choice.id] = false;
                        });
                    });


                    const initialToggleStates = data.map((poll) => poll.status === 'Active');
                    setToggleStates(initialToggleStates);

                    setUserVotes(initialUserVotes);
                    setTriggerRefresh((prev) => prev + 1);
                } else {
                    console.error('Failed to fetch poll data.');
                }
            } catch (error) {
                console.error('An error occurred:', error);
            } finally {
                setLoading(false);
            }
        }


        fetchPollData();
    }, []);




    const handleToggle = async (index) => {
        try {
            const pollId = pollData[index].id;
            const currentStatus = pollData[index].status;
            const newStatus = currentStatus === 'Active' ? 'Inactive' : 'Active';

            const accessToken = localStorage.getItem('accessToken');
            if (!accessToken) {
                throw new Error('Authentication credentials were not provided.');
            }

            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };

            const { status: responseStatus } = await api.put(`polls/${pollId}/`, { status: newStatus }, { headers });

            if (responseStatus === 200) {
                toast.success(`Poll status set to ${newStatus}`);


                setPollData((prevPollData) => {
                    const updatedPollData = [...prevPollData];
                    updatedPollData[index].status = newStatus;
                    return updatedPollData;
                });


                setToggleStates((prevToggleStates) => {
                    const updatedStates = [...prevToggleStates];
                    updatedStates[index] = newStatus === 'Active';
                    return updatedStates;
                });
            } else {
                toast.error('Failed to update poll status');
            }
        } catch (error) {
            console.error('An error occurred:', error);
            toast.error('Failed to update poll status');
        }
    };


    const [showAnnouncement, setShowAnnouncement] = useState(true);

    return (
        <>
            <div className="app-page-home">
                <Grid container spacing={2}>
                    <Grid item xs="12">
                        <div className="app-component-reportcard">
                            <div className="app-new-feeds">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6} lg={6} className={showAnnouncement ? "app-page-home__feeds" : undefined} style={{flexDirection:"column"}}>
                                        <div className="new-feeds-content">
                                            <div className="feeds-top-content">
                                                <h4>Survey / Polls</h4>
                                            </div>
                                        </div>
                                        <div className="report-problem-box">
                                            <div className="report-problem-box-content">
                                                <h4>Welcome</h4>
                                                <p>Please share your issue; we'll endeavor to provide the best possible solution and assistance.</p>
                                            </div>
                                            <div className="report-problem-form">
                                                <form>
                                                    <div className="form-group">
                                                        <label>Ask a Question</label>
                                                        <textarea value={pollQuestion} onChange={handleQuestionChange} className="input-form-2" rows="5"></textarea>
                                                    </div>
                                                    <div className="form-group option">
                                                        <label className="option">Options</label>
                                                        {pollChoices.map((choice, index) => (
                                                            <input
                                                                type="text"
                                                                key={index}
                                                                className="input-form"
                                                                value={choice}
                                                                onChange={(e) => handleChoiceChange(e, index)}
                                                                required
                                                            />
                                                        ))}
                                                    </div>
                                                    <div className="add-option">
                                                        <div className="add-option-buttons">
                                                            <Button onClick={handleAddChoice}>
                                                                <span>Add Option</span>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                    <div className="submit-report">
                                                        <Button onClick={() => {setShowAnnouncement(prev => !prev)}} style={{marginRight:"10px" , backgroundColor:"gray", borderColor:"gray"}}>Cancel</Button>
                                                        <Button onClick={handlePollSubmit}>Create Poll</Button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </Grid>

                                    <Grid item xs={12} md={6} lg={6} className={!showAnnouncement ? "app-page-home__feeds" : undefined}>
                                        <div className="option-share">
                                            <div className="new-feeds-content">
                                                <div className="feeds-top-content">
                                                    <h3 >Created polls</h3>
                                                    <div className="create-post-button mobile-only-button" style={{}}>
                                                        <Button onClick={() => {setShowAnnouncement(prev => !prev)}} style={{margin:"0px"}}>Create polls</Button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="phase-box polldata-scroll">
                                                {loading && <CircularProgress />}
                                                {pollData.map((poll, index) => (
                                                    <div className={`election-meeting ${poll.status === 'Inactive' ? 'inactive-poll' : ''}`} key={index}>
                                                        <div className="phase-box-content">
                                                            <div className="_0bpq">
                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                    <h3>{poll.question}</h3>
                                                                    <button
                                                                        style={{ border: 'none', backgroundColor: '#FAFAFA', fontSize: '35px' }}
                                                                        onClick={() => handleToggle(index)}
                                                                    >
                                                                        {toggleStates[index] ? <BsToggleOn /> : <BsToggleOff />}
                                                                    </button>
                                                                </div>
                                                                {poll.choices.map((choice, choiceIndex) => (
                                                                    <div className="_0cyc" key={choiceIndex}>
                                                                        <span className="choice-text">{choice.text}</span>
                                                                        <div className="linear-graph">
                                                                            <Tooltip title={`${choice.votes} votes`} arrow>
                                                                                <div
                                                                                    className="bar"
                                                                                    style={{
                                                                                        width: `${choice.votes > 0 ? (choice.votes / poll.total_votes) * 100 : 0}%`,
                                                                                    }}
                                                                                />
                                                                            </Tooltip>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                <div className="post-image"></div>
                                            </div>


                                        </div>
                                    </Grid>


                                </Grid>
                            </div>
                        </div>
                        {/* <PollCreator /> */}
                    </Grid>

                </Grid>
            </div>
            <ToastContainer />
        </>
    )
}

export default Survey_Polls;